import { render } from "./MarketplaceHeader.vue?vue&type=template&id=d3de6df8"
import script from "./MarketplaceHeader.vue?vue&type=script&lang=js"
export * from "./MarketplaceHeader.vue?vue&type=script&lang=js"

import "./MarketplaceHeader.vue?vue&type=style&index=0&id=d3de6df8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__